import React, { Component } from 'react';
import AssetForm from './asset-form/AssetForm';
import { actionCreators } from '../../../state/modals-dux';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import fetchDux from '../../../state/fetch-dux';
import RevisionModal from './RevisionModal';
import { formValueSelector } from 'redux-form';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import AssetDetailLayout from './AssetDetailLayout';

class CreateAsset extends Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.handleNewRevisionSubmit = this.handleNewRevisionSubmit.bind(this);
  }
  componentDidMount() {
    const {
      match,
      getType,
      clearGetType,
      clearPostAsset,
      getAssetSiblingsByParent,
      clearGetAssetSiblingsByParent
    } = this.props;

    const { params } = match || {};
    const { type, assetParentId: id } = params || {};
    clearGetType();
    clearPostAsset();
    clearGetAssetSiblingsByParent();
    getType(type);
    getAssetSiblingsByParent({ type, id });
  }
  submitForm(payload) {
    const { showModal } = this.props;
    showModal('CreateRevisionModal');
  }
  handleNewRevisionSubmit({ versionName }) {
    const { match, postAsset, formValues, closeModal } = this.props;
    const { params } = match || {};
    const { type, assetParentId } = params || {};
    closeModal();
    const payload = Object.assign(
      {},
      formValues,
      { versionName },
      assetParentId ? { assetParentId } : {}
    );
    postAsset({ type, payload }, 'asset-form', null, data => {
      const { insertedIds } = data || {};
      this.props.history.push(`/pages/${type}/${insertedIds[0]}`);
    });
  }
  render() {
    const { assetType, history, inProgress, assetSiblings, match } = this.props;
    const { opts } = assetType || {};
    const { label } = opts || {};

    const CancelButton = () => (
      <Link to={`/pages/${(assetType || {}).assetType}`}>
        <Button bsStyle="hollow-info">
          <span className="ti ti-close" /> Cancel
        </Button>
      </Link>
    );

    if (inProgress) return <div>Loading</div>;
    return (
      <div className="asset-background">
        <AssetDetailLayout
          assetSiblings={assetSiblings}
          asset={assetType}
          match={match}
          history={history}
        >
          <RevisionModal
            name="CreateRevisionModal"
            onRevisionSubmit={this.handleNewRevisionSubmit}
          />
          <AssetForm
            asset={assetType}
            onSubmit={this.submitForm}
            CancelButton={CancelButton}
          />
        </AssetDetailLayout>
      </div>
    );
  }
}

const selector = formValueSelector('asset-form');

const mapState = state => {
  const {
    result: assetType,
    inProgress,
    error
  } = state.getType.toJS();

  const {
    result: assetSiblings,
    error: assetSiblingsErr,
    inProgress: getAssetSiblingsInProgress
  } = state.getAssetSiblingsByParent.toJS();

  const formValues = {
    data: selector(state, 'data'),
    tags: selector(state, 'tags')
  };

  return {
    inProgress,
    formValues,
    assetType,
    error,
    assetSiblings
  };
};
const mapDispatch = dispatch =>
  bindActionCreators(
    {
      ...actionCreators,
      getType: fetchDux.getType.createAction,
      clearGetType: fetchDux.getType.clearAction,
      postAsset: fetchDux.postAsset.createAction,
      clearPostAsset: fetchDux.postAsset.clearAction,
      getAssetSiblingsByParent: fetchDux.getAssetSiblingsByParent.createAction,
      clearGetAssetSiblingsByParent: fetchDux.getAssetSiblingsByParent.clearAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(CreateAsset);



// WEBPACK FOOTER //
// ./src/components/routes/assets/CreateAsset.js